import React from 'react';

export default function AdvisorHeader() {
    return (
        <div className="px-xl-6 px-lg-5 px-4 pt-6">
            <div className="text-center">
                <h2 className="text-primary">Schedule an appointment</h2>
                <p>Sit down with one of the experienced wealth advisors in your area.</p>
            </div>
        </div>
    );
}
